import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import "./index.css";
import FrontPage from "./pages/FrontPage/FrontPage";
import AboutPage from "./pages/About/AboutPage";
import SubscriptionPage from "./pages/SubscriptionPage/SubscriptionPage";
import ContactPage from "./pages/ContactPage/ContactPage";
import LoginPage from "./pages/Platform/LoginPage/LoginPage";
import RegisterPage from "./pages/Platform/Register/RegisterPage";
import IndexPlatform from "./pages/Platform/IndexPlatform/IndexPlatform";
import VideoLibray from "./pages/Platform/VideoLibrary/VideoLibray";
import VideoPlayer from "./pages/Platform/VideoPlayer/VideoPlayer";
import ResetPasswordPage from "./pages/ResetPasswordPage/ResetPasswordPage";
import VideoLibraryPro from "./pages/Platform/VideoLibrary/VideoLibraryPro";
import SeriesDetailsPage from "./pages/Platform/SeriesDetailsPage/SeriesDetailsPage";
import LiveClassesPage from "./pages/Platform/LiveClasses/LiveClassesPage";
import UserDashboard from "./pages/Platform/UserPage/UserDashboard";
import RegisterPageTrial from "./pages/Platform/Register/RegisterPageTrial";
import PaymentSucessPage from "./pages/Platform/Register/PaymentSuccessPage";
import ChallengePage from "./pages/Platform/ChallengePage/ChallengePage";
import AdminPage from "./pages/Platform/Admin/AdminPage";
import RegisterPageFree from "./pages/Platform/Register/RegisterPageFree";
import PromoPage from "./pages/PromotionPage/PromoPage";
import PromoPageType1 from "./pages/PromotionPage/PromoPageType1";
import ChatPage from "./pages/Platform/ChatPage/ChatPage";
import MujerSoberanaPage from "./pages/Platform/MujerSoberana/MujerSoberanaPage";
import { getUserInfoByEmail } from "./services/user";
import { checkUserMembership } from "./utils/checkSubscription";
import { setCurrentUser } from "./redux/userRedux";

const extractUserPayload = (value) => {
  if (!value) return null;

  return (
    value?.data?.data ||
    value?.data?.user ||
    value?.data?.currentUser ||
    value?.data ||
    value?.user ||
    value?.currentUser ||
    null
  );
};

const resolveIsAdmin = (nextUser, previousUser) => {
  const candidate =
    nextUser?.isAdmin ??
    nextUser?.admin ??
    previousUser?.isAdmin ??
    previousUser?.admin ??
    false;

  if (typeof candidate === "boolean") return candidate;
  if (typeof candidate === "string") return candidate.toLowerCase() === "true";

  return Boolean(candidate);
};

function AppIndex() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.currentUser);
  const userEmail = user?.email || user?.user?.email || user?.currentUser?.email;

  useEffect(() => {
    const refreshCurrentUser = async () => {
      if (!userEmail) return;

      let latestUser = null;

      try {
        const res = await getUserInfoByEmail(dispatch, userEmail);
        latestUser = extractUserPayload(res);
      } catch (error) {
        console.error("Error fetching current user from server:", error);
      }

      if (!latestUser) return;

      const persistedPlans = Array.isArray(user?.subscriptionPlanId)
        ? user.subscriptionPlanId
        : [];
      const backendPlans = Array.isArray(latestUser?.subscriptionPlanId)
        ? latestUser.subscriptionPlanId
        : [];

      let activePlans = [...backendPlans, ...persistedPlans];

      try {
        const membershipList = await checkUserMembership(latestUser);
        const membershipPlans = (membershipList || [])
          .filter((subscriptionStatus) => subscriptionStatus.active)
          .map((subscriptionStatus) => subscriptionStatus.subscriptionName);

        activePlans = [...backendPlans, ...persistedPlans, ...membershipPlans];
      } catch (error) {
        console.error("Error checking user membership:", error);
      }

      const refreshedUser = {
        ...latestUser,
        isAdmin: resolveIsAdmin(latestUser, user),
        subscriptionPlanId: Array.from(new Set(activePlans.filter(Boolean))),
      };

      dispatch(setCurrentUser(refreshedUser));
    };

    refreshCurrentUser();
  }, [dispatch, userEmail]);

  const isAdmin = Boolean(user?.isAdmin);
  const indexPlatformElement = user ? <IndexPlatform /> : <LoginPage />;
  const adminElement = user && isAdmin ? <AdminPage /> : <LoginPage />;

  return (
    <>
      <Routes>
        <Route path="/" element={<FrontPage />} />
        <Route path="/Un-Poco-de-Mi" element={<AboutPage />} />
        <Route path="/subscripciones" element={<SubscriptionPage />} />
        <Route path="/contacto" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/payment-success" element={<PaymentSucessPage />} />
        <Route path="/promotion" element={<PromoPage />} />
        <Route path="/promotion/:token" element={<PromoPageType1 />} />
        <Route path="/registro" element={<RegisterPage />} />
        <Route path="/registro/:token" element={<RegisterPage />} />
        <Route path="/registro-mind/:token" element={<RegisterPageTrial />} />
        <Route path="/registro-body/:token" element={<RegisterPageTrial />} />
        <Route path="/registro-retoma-enciende-activa/:token" element={<RegisterPageTrial />} />
        <Route path="/registro-retoma-enciende-activa-ap/:token" element={<RegisterPageTrial />} />
        <Route path="/registro/:subcription/:token" element={<RegisterPage />} />
        <Route
          path="/registro-reto-estres-ansiedad/:token"
          element={<RegisterPageTrial />}
        />
        <Route
          path="/registro-usuario"
          element={<RegisterPageFree />}
        />
        <Route
          path="/registro-trail/:token"
          element={<RegisterPageFree />}
        />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route
          path="/index"
          element={indexPlatformElement}
        />
        <Route
          path="/user"
          element={user ? <UserDashboard /> : <LoginPage />}
        />
        <Route
          path="/yogaClasses"
          element={user ? <VideoLibraryPro /> : <LoginPage />}
        />
        <Route
          path="/library/:serieid"
          element={user ? <VideoLibray /> : <LoginPage />}
        />
        <Route
          path="/seriesDetails/:serieid"
          element={user ? <SeriesDetailsPage /> : <LoginPage />}
        />
        <Route
          path="/video/:videoid"
          element={user ? <VideoPlayer /> : <LoginPage />}
        />
        <Route
          path="/liveClasses"
          element={user ? <LiveClassesPage /> : <LoginPage />}
        />
        <Route
          path="/challenges"
          element={user ? <ChallengePage /> : <LoginPage />}
        />
        <Route
          path="/chat"
          element={user ? <ChatPage /> : <LoginPage />}
        />
        <Route
          path="/mujer-soberana"
          element={user ? <MujerSoberanaPage /> : <LoginPage />}
        />
        <Route
          path="/admin"
          element={adminElement}
        />
      </Routes>
    </>
  );
}

export default AppIndex;
